<div class="sp-mb-48">
  <h4>Current Toggle Usage:</h4>
  <div class="sp-mt-12">Basic Usage: <ui-toggle id="basic-toggle" [(ngModel)]="toggleValue"></ui-toggle></div>
  <div class="sp-mt-12">Disabled Usage: <ui-toggle [(ngModel)]="toggleValue" disabled></ui-toggle></div>
  <div class="sp-mt-12">Loading Indicator Usage: <ui-toggle [(ngModel)]="toggleValue" [toggleLoading]="true" disabled></ui-toggle></div>
  <div class="sp-mt-12">With Text: <ui-toggle [(ngModel)]="toggleValue" toggleType="toggle-text"></ui-toggle></div>
  <div class="sp-mt-12">With Icons: <ui-toggle [(ngModel)]="toggleValue" toggleType="toggle-icon"></ui-toggle></div>
  <div class="sp-mt-12">Small Toggle: <ui-toggle [(ngModel)]="toggleValue" toggleType="toggle-icon" [toggleSize]="'small'"></ui-toggle></div>
</div>
<div class="sp-mb-48">
  <h4>Legacy Toggle Usage:</h4>
  <h5>This is to be used only in Angular1 and not be used in Angular 12:</h5>
  <div class="sp-mt-12">Usage : <ui-toggle id="legacy-toggle" [key]="'test'" [value]="true" (onToggled)="doToggle($event)"></ui-toggle></div>
  <h5>Results</h5>
  <div>{{ legacyValues | json }}</div>
</div>
